<template>
  <div class="modern-chart-container">
    <div ref="chart" class="chart-inner"></div>
  </div>
</template>

<script>
export default {
  props: {
    zoomable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    draw(tree_data) {
      const my_chart = this.$echarts.init(this.$refs.chart);
      let option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e8e8e8',
          borderWidth: 1,
          padding: [8, 12],
          textStyle: {
            color: '#333',
            fontSize: 12
          }
        },
        series: [
          {
            type: "tree",
            data: [tree_data],
            top: "2%",
            left: "5%",
            bottom: "2%",
            right: "15%",
            symbolSize: 12,
            symbol: 'circle',
            initialTreeDepth: null,
            roam: this.zoomable,
            expandAndCollapse: false,
            itemStyle: {
              borderWidth: 2,
              shadowBlur: 4,
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowOffsetY: 2
            },
            lineStyle: {
              color: '#d9d9d9',
              width: 1.5,
              curveness: 0.5
            },
            label: {
              position: "left",
              verticalAlign: "middle",
              align: "right",
              fontSize: 11,
              color: '#595959',
              fontWeight: 500,
              distance: 8
            },
            leaves: {
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left",
              },
            },
            emphasis: {
              focus: "descendant",
              itemStyle: {
                borderWidth: 2,
                shadowBlur: 8,
                shadowColor: 'rgba(0, 0, 0, 0.2)'
              },
              lineStyle: {
                width: 2
              },
              label: {
                fontWeight: 600
              }
            },
            animationDuration: 400,
            animationDurationUpdate: 500,
          },
        ],
      };

      this.$nextTick(() => {
        my_chart.setOption(option)
      });
    },
  },
};
</script>

<style scoped>
.modern-chart-container {
  width: 100%;
  height: 500px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.chart-inner {
  width: 100%;
  height: 100%;
}
</style>
